(() => {
  function init(root) {
    root.querySelectorAll('[data-ln-product]').forEach((section) => {
      const form = section.querySelector('[data-ln-product-form]');
      if (!form || form.dataset.lnReady) return;
      form.dataset.lnReady = 'true';
      const input = form.querySelector('[name="id"]');
      const button = form.querySelector('.product-submit');
      const price = section.querySelector('[data-ln-price]');
      const error = form.querySelector('[data-ln-cart-error]');
      const status = form.querySelector('[data-ln-cart-status]');
      let busy = false;
      const selected = () => input.tagName === 'SELECT' ? input.selectedOptions[0] : input;
      const update = () => {
        const option = selected();
        if (option?.dataset.price) price.innerHTML = option.dataset.price;
        const available = option?.dataset.available === 'true';
        button.disabled = busy || !available;
        button.textContent = available ? 'Add to selection' : 'Sold out';
      };
      input.addEventListener('change', () => {
        update();
        error.hidden = true;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState(window.history.state, '', url);
      });
      update();
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy || button.disabled || !form.reportValidity()) return;
        const body = new FormData(form);
        // Shopify's bundled section response keeps the cart badge authoritative.
        body.set('sections', 'header');
        body.set('sections_url', window.location.pathname);
        busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        error.hidden = true;
        status.textContent = 'Adding to your selection.';
        try {
          const response = await fetch(form.action.replace(/\/?$/, '.js'), {
            method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' }
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this piece. Please try again.');
          let count;
          if (result.sections?.header) {
            const html = new DOMParser().parseFromString(result.sections.header, 'text/html');
            const badge = html.querySelector('[data-cart-count]');
            if (badge && /^\d+$/.test(badge.textContent.trim())) count = Number(badge.textContent.trim());
          }
          if (count === undefined) {
            try {
              const cartResponse = await fetch(form.dataset.cartUrl.replace(/\/?$/, '.js'), {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
              if (!cartResponse.ok) throw new Error('Cart refresh failed');
              count = (await cartResponse.json()).item_count;
            } catch (_) { /* The add succeeded: never repeat it or redirect. */ }
          }
          document.querySelectorAll('[data-cart-count]').forEach((badge) => {
            badge.textContent = Number.isInteger(count) ? String(count) : '+';
            const bag = badge.closest('a');
            bag?.setAttribute('aria-label', Number.isInteger(count) ? `Shopping bag, ${count} items` : 'Shopping bag, item added');
            bag?.classList.remove('ln-cart-added');
            if (bag) { void bag.offsetWidth; bag.classList.add('ln-cart-added'); }
          });
          status.textContent = 'Added to your selection.';
          document.dispatchEvent(new CustomEvent('ln:cart-updated', {detail: {itemCount: count}}));
        } catch (e) {
          error.textContent = e.message || 'Unable to add this piece. Please try again.';
          error.hidden = false;
          status.textContent = '';
        } finally {
          busy = false;
          button.removeAttribute('aria-busy');
          update();
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
